<template>
	<div class="affirmCom">
		<div class="titleBox">
			<span class="titleText">工单确认</span>
            <van-icon name="cross" size="20" class="closeIcon" @click="close"/>
		</div>
		<div class="tips">
			<span class="tipsText">请根据现场情况如实反馈，若回访不实将加倍处罚!</span>
		</div>
		<div class="formData">
			<div class="formLi">
				<div class="liLabelBox">
					<span class="isMust">*</span>
					<span class="label">是否搭电成功</span>
				</div>
				<div class="radioBox">
					<div class="radio" @click="checkRadio(1, '1')">
						<img :src="form.is_electrify == '1' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">是</span>
					</div>
					<div class="radio" @click="checkRadio(1, '0')">
						<img :src="form.is_electrify == '0' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">否</span>
					</div>
				</div>
			</div>
			<div class="formLi">
				<div class="liLabelBox">
					<span class="isMust">*</span>
					<span class="label">是否推销电瓶/配件</span>
				</div>
				<div class="radioBox">
					<div class="radio" @click="checkRadio(2, '1')">
						<img :src="form.is_promote_battery == '1' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">是</span>
					</div>
					<div class="radio" @click="checkRadio(2, '0')">
						<img :src="form.is_promote_battery == '0' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">否</span>
					</div>
				</div>
			</div>
			<div class="formLi">
				<div class="liLabelBox">
					<span class="isMust">*</span>
					<span class="label">是否更换电瓶/配件</span>
				</div>
				<div class="radioBox">
					<div class="radio" @click="checkRadio(3, '1')">
						<img :src="form.is_battery == '1' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">是</span>
					</div>
					<div class="radio" @click="checkRadio(3, '0')">
						<img :src="form.is_battery == '0' ? radio_y : radio_n" alt="" class="icon" />
						<span class="radioText">否</span>
					</div>
				</div>
			</div>
			<template v-if="form.is_battery == 1">
				<div class="formLi">
					<div class="liLabelBox">
						<span class="isMust">*</span>
						<span class="label">更换电瓶/配件费用</span>
					</div>
					<div class="valueBox">
                        <van-field class="inputBox" v-model="form.battery_cost" type="number" placeholder="输入更换电瓶/配件金额">
                            <template #extra>
								<span class="valueText">元</span>
                            </template>
                        </van-field>
					</div>
				</div>
				<div class="formLi noMargin">
					<div class="liLabelBox">
						<span class="isMust"></span>
						<span class="label">电瓶识别码</span>
					</div>
					<div class="valueBox">
                        <van-field class="inputBox" v-model="form.battery_code" placeholder="输入电瓶识别码"></van-field>
					</div>
				</div>
			</template>
		</div>
		<div class="affirmBtn" @click="submit">
			<span class="affirmText">确 认</span>
		</div>
	</div>
</template>

<script>
	import { confirmWork } from '@/apis/checkList';
	export default{
		props: {
			finishData: {
				type: Object | null,
				default: null
			},
			order: {
				type: String,
				default: ''
			}
		},
		data(){
			return {
                radio_n: require('@/assets/join/radio_n.png'),
                radio_y: require('@/assets/join/radio_y.png'),
				form: {
					order: '',
					is_electrify: '',		//是否搭电成功
					is_promote_battery: '',		//是否推销电瓶/配件
					is_battery: '',		//是否更换电瓶/配件
					battery_cost: '',		//费用金额
					battery_code: '',		//识别码
				}
			}
		},
		mounted() {
			this.form.order = this.order
		},
		methods: {
            close(){
                this.$emit('close')
            },
			checkRadio(type, val){
				if(type == 1){
					if(this.form.is_electrify == val) return
					this.form.is_electrify = val
				}else if(type == 2){
					if(this.form.is_promote_battery == val) return
					this.form.is_promote_battery = val
				}else if(type == 3){
					if(this.form.is_battery == val) return
					this.form.is_battery = val
				}
			},
			submit(){
				console.log('this.form', this.form)
				if(!this.form.is_electrify){
					this.$toast('请选择是否搭电成功！');
					return
				}
				if(!this.form.is_promote_battery){
					this.$toast('请选择是否推销电瓶/配件！');
					return
				}
				if(!this.form.is_battery){
					this.$toast('请选择是否更换电瓶/配件！');
					return
				}
				if(this.form.is_battery == 1 && !this.form.battery_cost){
					this.$toast('请输入更换电瓶/配件费用金额！');
					return
				}
				let params = {
					order: this.form.order,
					is_electrify: this.form.is_electrify == 1 ? 1 : 0,		//是否搭电成功
					is_promote_battery: this.form.is_promote_battery == 1 ? 1 : 0,		//是否推销电瓶/配件
					is_battery: this.form.is_battery == 1 ? 1 : 0,		//是否更换电瓶/配件
					battery_cost: this.form.is_battery == 1 ? this.form.battery_cost : '',		//费用金额
					battery_code: this.form.is_battery == 1 ? this.form.battery_code : '',		//识别码
				}
				confirmWork(params).then((res)=>{
					this.close()
					this.$emit('affirm', this.finishData)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
    .affirmCom{
        padding: 0 16px 20px;
        .closeIcon{
            position: absolute;
            top: 10px;
            right: 10px;
        }
		.titleBox{
		    height: 44px;
		    margin-bottom: 5px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			.titleText{
				font-size: 16px;
				font-weight: bold;
			}
		}
		.tips{
			margin-bottom: 12px;
			.tipsText{
				font-size: 14px;
				color: #F01C1C;
			}
		}
		.formData{
			background: #FAFAFA;
			border-radius: 5px;
			border: 1px solid #E4E4E4;
			padding: 12px;
			.formLi{
				margin-bottom: 20px;
				.liLabelBox{
					display: flex;
					flex-direction: row;
					.isMust{
						font-size: 15px;
						color: #F01C1C;
					}
					.label{
						font-weight: 600;
						font-size: 15px;
						color: #333333;
					}
				}
				.radioBox{
					margin-top: 13px;
					display: flex;
					flex-direction: row;
					align-items: center;
					.radio{
						flex: 1;
						display: flex;
						flex-direction: row;
						align-items: center;
						.icon{
							width: 16px;
							height: 16px;
							margin-right: 8px;
						}
						.radioText{
							font-size: 14px;
							color: #666666;
						}
					}
				}
                .valueBox{
					margin-top: 13px;
                    .inputBox{
                        background: #fff;
                        width: 100%;
                        height: 40px;
                        border-radius: 5px;
                        border: .5px solid #E4E4E4;
                        display: flex;
                        align-items: center;
                        .valueText{
                            font-size: 15px;
                            color: #666666;
                        }
                    }
                }
			}
			.noMargin{
				margin-bottom: 0;
			}
		}
		.affirmBtn{
			height: 40px;
			background: var(--theme-color);
			border-radius: 50px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			margin-top: 25px;
			.affirmText{
				font-weight: 600;
				font-size: 15px;
				color: var(--theme-btn);
			}
		}
	}
</style>